import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
const LAST_PARAMS_STORAGE_KEY = 'nanovnaweb.sweep.lastParams';
function readStoredParams() {
    try {
        const raw = globalThis.localStorage?.getItem(LAST_PARAMS_STORAGE_KEY);
        if (raw === null || raw === undefined)
            return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' ||
            parsed === null ||
            typeof parsed.start !== 'number' ||
            typeof parsed.stop !== 'number' ||
            typeof parsed.points !== 'number') {
            return null;
        }
        const p = parsed;
        if (!(p.start >= 0) || !(p.stop > p.start) || !(p.points >= 2))
            return null;
        return { start: p.start, stop: p.stop, points: p.points };
    }
    catch {
        return null;
    }
}
function writeStoredParams(p) {
    try {
        const payload = {
            start: Number(p.start),
            stop: Number(p.stop),
            points: p.points,
        };
        globalThis.localStorage?.setItem(LAST_PARAMS_STORAGE_KEY, JSON.stringify(payload));
    }
    catch {
        // localStorage unavailable (SSR, private mode, quota) — non-fatal.
    }
}
export function createSweepStore(deps) {
    const store = createStore()(() => ({
        params: null,
        isStreaming: false,
        lastParams: readStoredParams(),
    }));
    const actions = {
        async setParams(next) {
            const r = await deps.io.setSweep(next);
            if (r.kind === 'ok') {
                store.setState({ params: next, lastParams: next });
                writeStoredParams(next);
            }
            return r;
        },
        async startStream() {
            const r = await deps.io.startStream();
            if (r.kind === 'ok') {
                store.setState({ isStreaming: true });
            }
            return r;
        },
        async stopStream() {
            const r = await deps.io.stopStream();
            if (r.kind === 'ok') {
                store.setState({ isStreaming: false });
            }
            return r;
        },
        reset() {
            // Clearing the applied sweep on disconnect is intentional — the
            // current sweep is device-scoped. We deliberately keep `lastParams`
            // so the form still remembers the user's preferences for next
            // connection.
            store.setState({ params: null, isStreaming: false });
        },
    };
    return { store, actions };
}
export function useSweepStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=sweep-store.js.map